import { removeDuplicates } from './removeDuplicates';

export const mergeArrays = (arr1, arr2, key) => {
    return removeDuplicates(arr1?.concat?.(arr2), key);
};
